import axios from 'axios';
import moment from 'moment';
import { useState } from 'react';
import { config } from '../../../../config/Config';
import { handleMessage } from '../../../../helper/utils';
import { useTranslation } from 'react-i18next';

export default function useActionOrder({
  setSelectedTab,
  setCurrentPage,
  buildNewQueryStringWithFilter,
  buildFilterOrderWithRef,
}) {
  const { t } = useTranslation();

  const [isExportStc, setIsExportStc] = useState(false);
  const [isExportExcel, setIsExportExcel] = useState(false);

  const onChangeTab = (tab) => {
    setCurrentPage(1);
    setSelectedTab(tab);
  };

  const exportSTCExcel = async () => {
    setIsExportStc(true);

    try {
      const response = await axios.post(config.API_URL.ORDERS.EXPORT_STC_EXCEL, null, {
        params: {
          ...buildNewQueryStringWithFilter(buildFilterOrderWithRef()),
        },
        headers: {
          ...config.headers,
        },
      });
      if (response?.status === 200) {
        handleMessage(
          'success',
          'Your export request is being processed. The file will be sent to your email when it’s ready.'
        );
        setIsExportStc(false);
      } else {
        handleMessage('error', 'Something is wrong with the process, please try again.');
        setIsExportStc(false);
      }
    } catch (errors) {
      setIsExportStc(false);
      handleMessage('error', 'Something is wrong with the process, please try again.');
    } finally {
    }
  };

  const exportExcel = () => {
    setIsExportExcel(true);
    try {
      axios
        .post(config.API_URL.ORDERS.EXPORT_EXCEL, null, {
          params: {
            ...buildNewQueryStringWithFilter(buildFilterOrderWithRef()),
          },
          headers: {
            ...config.headers,
            'Content-Disposition': 'attachment; filename=template.xlsx',
            'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          },
          responseType: 'arraybuffer',
        })
        .then((response) => {
          if (response?.status === 200) {
            handleMessage('success', t('export_excel_success'));
          }
          setIsExportExcel(false);
          // const url = window.URL.createObjectURL(new Blob([response.data]));
          // const link = document.createElement('a');
          // link.href = url;
          // link.setAttribute('download', `order-${moment().locale('en').format('MM-DD-YYYY')}.xlsx`);
          // document.body.appendChild(link);
          // link.click();
        });
    } catch (errors) {
      handleMessage('error', t('export_excel_fail'));
      setIsExportExcel(false);
    }
  };

  return {
    setSelectedTab,
    onChangeTab,
    exportSTCExcel,
    exportExcel,
    isExportStc,
    isExportExcel,
  };
}
